function VerifyEmailPage() {
    return (
        <div className='text-center'>
                <h1 className='text-dark mb-3'>Correo electrónico enviado</h1>
                <div className="text-gray-400 fw-bold fs-4">Se ha enviado un mensaje a su correo electrónico, por favor, revíselo y siga las instrucciones para finalizar el proceso de cambio de su contraseña.</div>
            </div>
       
    )
}

export default VerifyEmailPage
